module.exports = __webpack_public_path__ + "static/media/snoopynight-doghouse.65ede335.gif";